<style lang="scss" scoped>
::v-deep .tns-ovh {
    overflow: visible;
}
</style>

<template>
    <section v-if="jobs && jobs.length > 0">
        <h2 v-if="title !== ''" class="text-h3 lg:text-h2 text-dark font-mon mb-8 font-bold" :class="{ 'mb-8': description !== '', 'mb-24': description === '' }" v-html="title"></h2>
        <div v-if="description !== ''" class="text-small text-dark font-mon mb-24" v-html="description"></div>
        <div ref="faketainer" class="container"></div>
        <div ref="slider" class="job-slider">
            <div v-for="job in jobs" :key="job.id">
                <job-card :job="job" :class="{ large: rowCount < 4 }" />
            </div>
        </div>
    </section>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider";

export default {
    props: {
        title: {
            default: "",
            required: false
        },
        description: {
            default: "",
            required: false
        },
        excludeId: {
            type: [Number, false],
            required: false
        },
        sector: {
            type: [String, false],
            required: false
        },
        rowCount: {
            type: Number,
            default: 4,
            required: false
        },
        perPage: {
            type: Number,
            default: 4,
            required: false
        }
    },

    data: () => ({
        loading: false,
        success: false,
        jobs: [],
        slider: null
    }),

    mounted() {
        this.getJobs();
    },

    methods: {
        getJobs() {
            this.loading = true;
            const params = {
                per_page: this.perPage
            };

            if (this.excludeId) {
                params.excludeId = this.excludeId;
            }

            if (this.sector) {
                params.sector = [this.sector];
            }

            axios
                .get("/api/jobs", { params })
                .then(response => this.initSlider(response.data))
                .finally(() => (this.loading = false));
        },
        initSlider(data) {
            this.jobs = data;
            
            this.$nextTick(() => {
                if (!this.$refs.slider) {
                    return;
                }

                this.slider = tns({
                    container: this.$refs.slider,
                    items: 1.3,
                    gutter: 16,
                    preventScrollOnTouch: "force",
                    mouseDrag: true,
                    loop: false,
                    gutter: 16,
                    controls: false,
                    nav: false,
                    swipeAngle: false,
                    responsive: {
                        768: {
                            items: 2.3,
                            gutter: 24
                        },
                        1024: {
                            items: this.rowCount,
                            gutter: 24
                        }
                    }
                });
            });
        }
    }
};
</script>
